export default __webpack_public_path__ + "static/media/linkedin.09a5d4dc.svg";